export default "__VITE_ASSET__CfJgauOR__"